import { JSX, ReactNode } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";

import { RootState } from "store/types";
import { isPlgPath } from "plg/routes";

interface GoogleAuthGateProps {
  children: ReactNode;
}

function GoogleAuthGate({ children }: GoogleAuthGateProps): JSX.Element {
  const { pathname } = useLocation();
  const clientId = useSelector(
    (state: RootState) => state.PlatformConfig?.platformConfig?.payload?.GOOGLE_CLIENT_ID,
  );

  // PRD-3334: PLG pages never get the provider (see isPlgPath).
  if (!clientId || isPlgPath(pathname)) {
    return <>{children}</>;
  }

  return <GoogleOAuthProvider clientId={clientId}>{children}</GoogleOAuthProvider>;
}

export default GoogleAuthGate;
